import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import moment from 'moment';

// Global Types
import { AppState } from 'services/types';
import {
    MyTimesheetEntryDate,
    MyTimesheetEntriesProps
} from 'services/myTimesheetEntries/types';

// Global Selectors
import { makeSelectMyTimesheetEntryDate } from 'services/myTimesheetEntries/selectors';

type OwnProps = MyTimesheetEntriesProps;

interface ConnectedProps {
    date?: MyTimesheetEntryDate;
}

type Props = OwnProps & ConnectedProps;

export class MyTimesheetEntryDateValue extends React.PureComponent<Props> {
    render(): string | null {
        const { date } = this.props;
        if (!date) {
            return null;
        }
        return moment(date, 'YYYY-MM-DD').format('dddd, MMM DD');
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    date: makeSelectMyTimesheetEntryDate()
});

export default connect(mapStateToProps)(MyTimesheetEntryDateValue);
